'use client';
import { IconUpload, IconX } from '@tabler/icons-react';

import { DropZone } from '@aws-amplify/ui-react';
import { Loader } from '@mantine/core';
import { useRef } from 'react';

const acceptedFileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

interface IProps {
  isLoading: boolean;
  disabled: boolean;
  displayInstructions?: boolean;
  handleUpload: (file: File) => Promise<void>;
}

export const Dropzone = ({
  isLoading,
  disabled,
  handleUpload,
  displayInstructions = false,
}: IProps) => {
  //   const [files, setFiles] = useState<any[]>([]);
  const hiddenInput = useRef(null);

  const onFilePickerChange = async (event: any) => {
    const { files } = event.target;
    if (!files || files.length === 0) {
      return;
    }
    await handleUpload(files[0]);
    event.target.value = '';
  };

  const renderDefautlState = () => {
    if (!displayInstructions) {
      return <IconUpload />;
    }

    return (
      <div className="flex flex-col items-center gap-4 ">
        <IconUpload />
        <p className="text-text-secondary font-lg">
          Drop your file here, or{' '}
          <span className="font-bold text-primary-500 underline">Browse</span>
        </p>
      </div>
    );
  };

  return (
    <DropZone
      isDisabled={disabled}
      acceptedFileTypes={acceptedFileTypes}
      onDropComplete={async ({ acceptedFiles }) => {
        if (acceptedFiles && acceptedFiles.length > 0 && acceptedFiles[0]) {
          await handleUpload(acceptedFiles[0]);
        }
      }}
    >
      <div
        onClick={() => {
          if (!disabled) {
            // @ts-ignore
            hiddenInput?.current?.click();
          }
        }}
        style={{ height: '8rem' }}
        className={`${disabled ? 'cursor-not-allowed border-gray-500 text-gray-500' : 'cursor-pointer text-primary-500 border-primary-500'} flex justify-center mb-4 border-dashed border rounded-2xl mx-6`}
      >
        <div
          className="flex flex-col items-center"
          style={{ marginTop: '35px' }}
        >
          <DropZone.Accepted>
            {isLoading ? <Loader size="sm" /> : <IconUpload />}
          </DropZone.Accepted>
          <DropZone.Rejected>
            <IconX />
          </DropZone.Rejected>
          <DropZone.Default>
            {isLoading ? <Loader size="sm" /> : renderDefautlState()}
          </DropZone.Default>

          <input
            hidden
            type="file"
            tabIndex={-1}
            ref={hiddenInput}
            disabled={disabled}
            onChange={onFilePickerChange}
            multiple={false}
            accept={acceptedFileTypes.join(',')}
          />
        </div>
      </div>
    </DropZone>
  );
};
